import {
  combine,
  withMemo,
  withContext,
  withCallbacks,
} from 'react-hooks-combine'
import { ServicesContext } from 'services/context'
import { withTableController } from 'shared/hooks'

import TransHistorySponsorComponent from './component'
import { createColumns } from './columns.description'

export default combine(
  withTableController({ id: 'transHistorySponsor-table' }),

  withContext(
    'sponsorsService',
    ServicesContext,
    ({ sponsorsService }) => sponsorsService
  ),

  withMemo('columns', () => createColumns(), []),

  withCallbacks(
    {
      loadTransHistory:
        ({ sponsorsService }) =>
        (tableState, _table, query) => {
          const isHaveSearch = !!query?.search
          return sponsorsService.getSponsorTransHistory({
            page: tableState.page,
            size: tableState.pageSize,
            ...(isHaveSearch ? { matchNameSearch: query?.search } : {}),
            tournamentId: query?.tournamentId,
            sportType: query?.sport,
            includeZero: true,
          })
        },
      onSearch:
        ({ table }) =>
        (query) => {
          table.search(query)
        },
    },
    []
  )
)(TransHistorySponsorComponent)
